import React from 'react'

interface IToolTipProps {
  value: string;
  count?: number;
}

const ToolTip = (props: IToolTipProps) => {
  const { value, count } = props;

  const new_count = count ?? 10;

  return (
    <div className="tooltip-main">
      <div className="init">{value?.length > new_count ? `${value?.substring(0, new_count)}...` : value}</div>
      {value?.length > new_count ? <div className="tool-tip-box">
        <div className="tool-tip-inner">{value}</div>
      </div> : <></>}
    </div>
  )
}

export default ToolTip